import * as React from "react";
import { observer } from "mobx-react";
import { large } from "../../style/button";
import { css } from "@emotion/core";
import { RouteComponentProps } from "react-router-dom";
import { useEffect } from "react";
import { Footer } from "../organisms/Footer";

export const InquiryDone = observer(({ history }: RouteComponentProps) => {
  useEffect(() => {
    // Google analytics
    // @ts-ignore
    gtag("event", "conversion", {
      send_to: "AW-940000918/DNCnCP_a76oBEJaNncAD"
    });

    // Yahoo
    // @ts-ignore
    window.yahoo_conversion_id = 1000901430;
    // @ts-ignore
    window.yahoo_conversion_label = "VehYCOOT16sBENOpqcUD";
    // @ts-ignore
    window.yahoo_conversion_value = 0;
    const script = document.createElement("script");
    script.src = "https://s.yimg.jp/images/listing/tool/cv/conversion.js";
    document.head.append(script);
  }, []);
  return (
    <div>
      <h2>資料請求ありがとうございました。</h2>
      <p
        css={css`
          margin-bottom: 50px;
        `}
      >
        メールアドレスをご登録頂いた方には、オンライン資料を添付したメールをお送りさせて頂きました。
        <br />
        万が一届かない場合は大変お手数ですが、ご連絡ください。
      </p>

      <div
        css={css`
          margin: 0 40px;
        `}
      >
        <button
          onClick={() => {
            history.push("/application/order");
          }}
          css={large}
        >
          お申込み/お見積ページ
        </button>
      </div>

      <div
        css={css`
          display: flex;
          justify-content: center;
          margin: 20px;
        `}
      >
        <a href="http://s.selects.jp/yvOI" target="postal-order-guide-pdf">
          お申込みガイド(PDF)
        </a>
      </div>

      <Footer />
    </div>
  );
});
